import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, Package, BookOpen, HelpCircle, ShoppingBag, MessageSquare, Bot, Settings, LogOut, Fish } from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders & Bookings", icon: ShoppingBag },
  { to: "/admin/blog", label: "Blog", icon: BookOpen },
  { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
  { to: "/admin/messages", label: "Messages", icon: MessageSquare },
  { to: "/admin/chatbot", label: "Chatbot Config", icon: Bot },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;

  const handleLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen flex bg-gray-100" data-testid="admin-layout">
      <aside className="admin-sidebar w-64 flex-shrink-0 hidden md:flex flex-col">
        <div className="p-6 flex items-center gap-2 border-b border-white/10">
          <Fish className="w-6 h-6 text-[color:var(--color-accent)]" />
          <div className="font-display text-xl">AlikamaFish</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded text-sm ${isActive ? "active" : ""}`
              }
            >
              <it.icon className="w-4 h-4" />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button onClick={handleLogout} className="flex items-center gap-2 px-3 py-2 text-sm text-white/70 hover:text-white w-full" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="md:hidden bg-[color:var(--color-primary)] text-white p-4 flex items-center justify-between">
          <div className="font-display text-lg">AlikamaFish Admin</div>
          <button onClick={handleLogout} className="text-xs">Logout</button>
        </div>
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
